module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wxc-tag', 'border-' + _vm.tagTheme],
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.newTheme.divStyle))
  }, [_c('text', {
    class: ['tag-text', _vm.tagTheme],
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.newTheme.textStyle))
  }, [_vm._v(_vm._s(_vm.tagValue))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8c80ddc2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c80ddc2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-rich-text/wxc-rich-text-tag.vue
// module id = 192
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28